import React from 'react';
import styled, { css } from 'styled-components';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
  space, layout, position, color, typography, flexbox, border, variant,
} from 'styled-system';
import { Button } from './styles';

export const Box = styled.div`
  ${space};
  ${layout};
  ${position};
  ${color};
  ${typography};
  ${flexbox};
  ${border}
`;

export const Flex = styled(Box)`
  display: flex;
  ${(props) => props.column && css`flex-direction: column;`};
  ${(props) => props.wrap && css`flex-wrap: wrap;`};
`;

export const Text = styled(Box)`
  ${(props) => props.semibold && css`
    font-weight: 600;
  `};
  ${(props) => props.bold && css`
    font-weight: 800;
  `};
  ${(props) => props.cap && css`
    text-transform: capitalize;
  `}
  ${(props) => variant(props.theme.texts)}
`;

// Sometimes, action is disabled due to some reasons,
// display a note to explain why
export function ActionNote({ text }) {
  return (
    <Text fontSize={12} color="gray" mt={1}>
      {text}
    </Text>
  );
}

// Checkbox component
// https://medium.com/@colebemis/building-a-checkbox-component-with-react-and-styled-components-8d3aa1d826dd
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // Hide checkbox visually but remain accessible to screen readers.
  // Source: https://polished.js.org/docs/#hidevisually
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #dee1ec;
  transition: all 150ms;
  & svg {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')}
  }
`;
const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;
export function Checkbox({ className, checked, ...props }) {
  return (
    <CheckboxContainer className={className}>
      <HiddenCheckbox checked={checked} {...props} />
      <StyledCheckbox checked={checked}>
        <svg fill="none" stroke="#108ee9" strokeWidth="3px" viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </StyledCheckbox>
    </CheckboxContainer>
  );
}

export const Link = styled.a`
  color: #108EE9;
`;
export function DisabledActionButton({ buttonText, disableNote }) {
  disableNote = disableNote || 'You cannot complete this step in Preview Mode.';
  return (
    <Flex column alignItems="flex-end">
      <Button
        disabled
      >
        { buttonText || 'Submit' }
      </Button>
      <ActionNote text={disableNote} />
    </Flex>
  );
}

export const AssigneeLabel = styled(Box)`
    display: flex;
    color: white;
    align-items: center;
    padding: 4px 11px;
    border-radius: 2px;
    font-size: 10px;
    font-weight: 600;
    margin-right: 8px;
    margin-top: 5px;
`;

export const ActionStatus = styled(Box)`
  position: absolute;
  top: 6px;
  right: 12px;
  padding: 4px 9px;
  color: white;
  font-size: 10px;
  border-radius: 2px;
`;

export const Loading = styled.div`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%);
`;

export const FormTag = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 15px;
  background: #F2F5FA;
  height: 35px;
  width: fit-content;
  font-weight: bold;
  font-size: 12px;
  line-height: 27px;
  color: #525252;
`;

export const InfoContainer = styled.div`
  background: #f2f6ff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export function StateTaxFormInfo({ className }) {
  return (
    <InfoContainer className={className}>
      <InfoCircleOutlined
        color="#457CFF"
        style={{
          fontSize: '24px',
          marginRight: '12px',
          color: '#457CFF',
        }}
      />
      <Text
        style={{
          color: '#464D5D',
          fontSize: '14px',
        }}
      >
        Please scroll down to review your information before finalizing.
      </Text>
    </InfoContainer>
  );
}
